import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Solution(props) {
    return (
        <div className="services_solution  p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="Development">
                            <h2>Ecommerce Development Solutions</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                        <p>We channel technical ecommerce development and digital product solutions depending on
                            entrepreneurs' business journeys.</p>
                        <ul>
                            <li><strong>Ecommerce Web Development Service</strong></li>
                            <p>This is an on-point, on-budget store option for businesses newly tapping the product side
                                of electronic commerce. These are secure and SEO-friendly.</p>
                            <li><strong>Ecommerce App Development Service&nbsp;</strong></li>
                            <p>Mobile apps are the most common form of digital commerce enablement. These have
                                omnichannel payment methods and send out personalized product recommendations.</p>
                            <li><strong>Ecommerce Software Development Service&nbsp;</strong></li>
                            <p>Ecommerce software programs, especially SaaS, are ideal for medium to large-scale
                                ecommerce businesses. With multiple payment methods, these programs have multiple
                                backends for different roles and profiles, </p>
                        </ul>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Solution;